<script setup lang="ts">
import ErrorLayout from "@/components/errors/ErrorLayout.vue";
import { useI18n } from "@/composables/useI18n";
import { IonButton } from "@ionic/vue";
import AppVersion from "@/components/ui/AppVersion.vue";

import { useFabriqStore } from "@/store/fabriq";

const fabriqStore = useFabriqStore();
defineProps<{
  disabled: boolean;
}>();

const emit = defineEmits<{
  (e: "click"): void;
}>();

const { t } = useI18n();
</script>

<template>
  <error-layout>
    <div />
    <div class="ion-padding">
      <div class="ion-padding error-text">
        {{ t("common.initializationError") }}
      </div>
      <ion-button
        expand="block"
        color="secondary"
        mode="ios"
        :disabled="disabled"
        @click="emit('click')"
      >
        {{ t("common.resetApplicationConfiguration") }}
      </ion-button>
    </div>
    <AppVersion :version="fabriqStore.version" position="relative" />
  </error-layout>
</template>

<style scoped>
.error-text {
  text-align: center;
}
</style>
